import authService from '../../services/AuthService';
var HasFeature = function (_a) {
    var feature = _a.feature, _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.fallback, fallback = _c === void 0 ? null : _c;
    if (!children)
        return null;
    if (!authService.hasFeature(feature)) {
        return fallback;
    }
    return children;
};
export default HasFeature;
